import routes from '../../routes/routes'
import styles from './styles.module.scss'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import constants from '../../utils/constants'

export function Menu(state) {
  const navigate = useNavigate()
  const [selectedPage, setSelectedPage] = useState(state.state)
  const JUDITE_URL = constants.JUDITE_URL

  const handleHome = () => {
    navigate(routes.ContactList.path, { replace: true })
  }

  const handleCallHistory = () => {
    navigate(routes.CallHistoryPage.path, { replace: true })
  }

  const handleDial = () => {
    navigate(routes.DialerPage.path, { replace: true })
  }

  const ButtonProperties = [
    {name: 'Início', checkedImage: `${JUDITE_URL}/CheckedHome.svg`, uncheckedImage: `${JUDITE_URL}/HomeButton.svg`, alt: 'Home Page', function: handleHome},
    {name: 'Recentes', checkedImage: `${JUDITE_URL}/CheckedRecent.svg`, uncheckedImage: `${JUDITE_URL}/RecentButton.svg`, alt: 'Recents', function: handleCallHistory},
    {name: 'Teclado', checkedImage: `${JUDITE_URL}/CheckedKeyBoard.svg`, uncheckedImage: `${JUDITE_URL}/KeyBoardButton.svg`, alt: 'Dialer', function: handleDial},
  ]
  
  return(
  <div className={styles.Wrapper}>
    <div className={styles.divider}/>

    <div className={styles.container}>
        {ButtonProperties.map(buttonProperty => (
          <div className={styles.alignComponents} key={buttonProperty.name}>
            <button className={styles.button} type="button" 
            onClick={() => {
                    buttonProperty.function();
                    setSelectedPage(buttonProperty.name);
                }
            }>
                <img src={
                    selectedPage === buttonProperty.name ? 
                    buttonProperty.checkedImage : 
                    buttonProperty.uncheckedImage} 
                    alt={buttonProperty.alt}
                />
            </button>
            <div className={`${selectedPage === buttonProperty.name ? styles.textChecked : styles.textUnchecked}`}>
                {buttonProperty.name}
            </div>  
          </div>
        ))}
    </div>
  </div>
  )
}